<template>
  <div class="error-page">
    <div class="error-img">
      <img src="../../assets/images/error-500.png" alt />
    </div>
    <div class="error-result">{{ errorMessage }}</div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { api } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      errorMessage: "数据请求中,请稍候......",
    };
  },
  mounted() {
    this.initParams();
  },
  methods: {
    initParams() {
      let fullQuery = this.$route.query;
      if (!fullQuery) return;
      const embed = fullQuery.embed;
      api.authWithCourse(this.siteConfig.agencyId, fullQuery).then((res) => {
        console.log(res);
        if (res.status === 1) {
          this.login(res.data.user);
          //this.$router.push({ name: "MemberCenter" });
          setTimeout(() => {
            if (embed && embed == 1) {
              this.$router.push({
                name: "CourseStudyApi",
                params: { cid: res.data.user.courseId },
              });
            } else if (embed && embed == 2) {
              this.$router.push({
                name: "MemberCenter",
              });
            } else {
              this.$router.push({
                name: "CourseStudy",
                params: { cid: res.data.user.courseId },
              });
            }
          }, 1000);
        } else {
          this.errorMessage = res.message;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.error-page {
  margin-top: 50px;
  .error-img {
    width: 255px;
    height: 295px;
    margin: 0 auto;
  }
  .error-result {
    margin-top: 3rem;
    font-size: 1.8rem;
    text-align: center;
  }
}
</style>
